import Index from "../../pages/snail/5thReport/index";
import Pc from "../../pages/snail/5thReport/pc";
import chatModule from "../../pages/snail/5thReport/components/chatModule";

const base = "5thReport";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/chatModule`,
    name: `${base}-chatModule`,
    component: chatModule
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/5thReport.js